import React, { useState } from 'react';
import { useUser } from './contexts/UserContext';
import LoadingScreen from './components/LoadingScreen';
import Dashboard from './components/Dashboard';

export default function Home() {
  const [error, setError] = useState('');
  const { userData, isLoading } = useUser();

  // Show loading screen while loading
  if (isLoading) {
    return <LoadingScreen />;
  }

  // If userData is undefined, there was an error
  if (userData === undefined) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-red-500">Failed to load user data. Please try refreshing the page.</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-red-500">{error}</div>
      </div>
    );
  }

  return (
    <div className="flex flex-col h-screen">
      {/* Dashboard Component */}
      <Dashboard />
    </div>
  );
}
 
 